var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"otp-wrapper"},_vm._l((_vm.field.codeLength),function(i){return _c('input',{key:i,attrs:{"type":"text","readonly":_vm.field.readonly,"maxlength":"1"},on:{"keyup":function($event){return _vm.inputChanged($event, i)},"paste":function($event){return _vm.onPaste($event, i)}}})}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }